// src/store/store.js
import { configureStore } from '@reduxjs/toolkit';
import tripsReducer from '../api/tripSlice';

const store = configureStore({
  reducer: {
      trips: tripsReducer,
  },
});

export default store;